(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rodentlab-pawmed-story"] && !Shopify.designMode) return;
  try {
    
  function initZkhPawmedPage() {
    var story = document.querySelector('[data-zkh-pawmed-story]');
    var productArea = document.querySelector('[id^="MainProduct-"]');
    if (!story || !productArea || productArea.dataset.pwmEnhanced === 'true') return;
    productArea.dataset.pwmEnhanced = 'true';

    var colorInput = productArea.querySelector('variant-selects input[name="Color"]:checked');
    var colorFieldset = colorInput ? colorInput.closest('.product-form__input') : null;
    var colorLegend = colorFieldset ? colorFieldset.querySelector('.form__label') : null;
    function updateColorLegend() {
      var selected = productArea.querySelector('variant-selects input[name="Color"]:checked');
      if (colorLegend && selected) colorLegend.textContent = 'Color - ' + selected.value;
    }
    function syncGalleryToColor() {
      var selected = productArea.querySelector('variant-selects input[name="Color"]:checked');
      if (!selected) return;
      var expectedAlt = selected.value + ' RodentLab ultrasonic dog teeth cleaner with scaler tip';
      var thumbnailButtons = document.querySelectorAll('button[aria-label^="Load image"]');
      var matchingButton = Array.prototype.find.call(thumbnailButtons, function (button) {
        var image = button.querySelector('img[alt]');
        return image && image.alt === expectedAlt;
      });
      if (matchingButton) matchingButton.click();
    }
    updateColorLegend();
    window.setTimeout(syncGalleryToColor, 0);
    if (document.readyState === 'complete') {
      window.setTimeout(syncGalleryToColor, 250);
    } else {
      window.addEventListener('load', function () {
        window.setTimeout(syncGalleryToColor, 250);
      }, { once: true });
    }
    productArea.querySelectorAll('variant-selects input[name="Color"]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateColorLegend();
        window.setTimeout(syncGalleryToColor, 50);
      });
    });

    var kitInputs = productArea.querySelectorAll('variant-selects input[name="Kit"]');
    if (kitInputs.length) {
      var kitLegend = kitInputs[0].closest('.product-form__input').querySelector('.form__label');
      if (kitLegend) kitLegend.textContent = 'CHOOSE YOUR KIT';
    }

    kitInputs.forEach(function (input) {
      var label = productArea.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      if (input.value === 'Starter Kit') {
        label.innerHTML =
          '<span class="pwm-kit-card__top">Starter Kit</span>' +
          '<span class="pwm-kit-card__desc">Get started with at-home dental cleaning</span>' +
          '<span class="pwm-kit-card__list">✓ Ultrasonic Dental Cleaner<br>✓ 1 Scaler Tip + Wrench<br>✓ Charging Cable<br>✓ Easy Setup Guide<br>✓ Basic Setup Video</span>';
      }
      if (input.value === 'Full Cleaning Kit' || input.value === 'Complete Dental Care Kit') {
        var completeKitName = input.value === 'Complete Dental Care Kit' ? 'Complete Dental Care Kit' : 'Full Cleaning Kit';
        label.innerHTML =
          '<span class="pwm-kit-card__top">' + completeKitName + '</span>' +
          '<span class="pwm-kit-card__desc">Recommended for full at-home cleaning sessions</span>' +
          '<span class="pwm-kit-card__list">✓ Ultrasonic Dental Cleaner<br>✓ 3× Scaler Tips + Wrench<br>✓ Charging Cable<br>✓ Easy Setup Guide<br>✓ Full Video Tutorial<br>✓ Free Shipping</span>';
      }
    });

    var variantQuery = new URLSearchParams(window.location.search);
    if (!variantQuery.has('variant')) {
      var selectDefaultStarterKit = function () {
        var starterKitInput = Array.prototype.find.call(kitInputs, function (input) {
          return input.value === 'Starter Kit';
        });
        if (!starterKitInput) return;
        if (starterKitInput.checked) {
          starterKitInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          starterKitInput.click();
        }
      };
      if (document.readyState === 'complete') {
        window.setTimeout(selectDefaultStarterKit, 0);
      } else {
        window.addEventListener('load', function () {
          window.setTimeout(selectDefaultStarterKit, 0);
        }, { once: true });
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-zkh-pawmed-buy]');
      if (!trigger) return;
      event.preventDefault();
      productArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZkhPawmedPage);
  } else {
    initZkhPawmedPage();
  }
  document.addEventListener('shopify:section:load', initZkhPawmedPage);

  } catch(e) { console.error(e); }
})();
})();
